import API from '@/services/api';
import router from '@/router';

export default {
  fetchFeedingsByStudent() {
    return API().get(`students/${router.currentRoute.params.id}/feedings`);
  },
  fetchFeedingByTeacher() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-feedings`
    );
  },
  fetchOneDateFeedingByTeacher(params) {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-feedings/${params.date}`
    );
  },
  addOneDateFeedingeByTeacher(params) {
    params.map(item => {
      delete item.student_name;
      delete item.id;
      item.date = item.feeding_date;
      delete item.feeding_date;
      return item;
    });

    const filteredParams = params.filter(i => i.category.length);

    return API().post(
      `teachers/${router.currentRoute.params.id}/student-feedings`,
      filteredParams
    );
  },
  bulkUpdateOneDateFeedingeByTeacher(params) {
    params.map(item => {
      delete item.student_name;
      return item;
    });

    return API().put(
      `teachers/${router.currentRoute.params.id}/student-feedings`,
      params
    );
  },
  addBulkFeedingRecords(params) {
    params.map(item => {
      delete item.student_name;
      delete item.id;
      return item;
    });
    return API().post(
      `teachers/${router.currentRoute.params.id}/student-feedings`,
      params
    );
  },
  fetchFeedingSummaryTable() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-feedings-summary`
    );
  },
};
